export { SortableModule } from './sortable.module';
export { SortableComponent } from './sortable.component';
export { DraggableItemService } from './draggable-item.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/sortable/index.js
// module id = 332
// module chunks = 5